import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from "typeorm";
import { CommonColumns } from "./common-columns.entity";
import { CxQuestionOption } from "./cx-question-option.entity";
import { CxQuestionPage } from "./cx-question-page.entity";

export enum QuestionType {
  SELECT_SCORE = 'selectScore',
  FREE_TEXT = 'freeText',
  DROPDOWN = 'dropdown',
  RADIO_BUTTON = 'radioButton',
  CHECKBOX = 'checkBox',
  ZIPCODE = 'zipcode',
  CALENDAR = 'calendar',
}

export type SCORE_VAL = 1|2|3|4|5|6|7|8|9|10;

@Entity()
export class CxQuestion extends CommonColumns {

  @ManyToOne(() => CxQuestionPage, cxQuestionPage => cxQuestionPage.cxQuestions, { nullable: false, })
  @JoinColumn({ name: 'cx_question_page_id', referencedColumnName: 'id', })
  cxQuestionPage: CxQuestionPage;

  @Column({ default: true, })
  enable_question: boolean;

  @Column({ default: true, })
  required: boolean;

  @Column({
    name: 'question_type',
    enum: QuestionType,
  })
  questionType: QuestionType;

  @Column({ name: 'question_type_attr', })
  questionTypeAttr: string;

  // 便宜上、SELECT_SCORE以外の質問タイプの時も設定する
  @Column({ name: 'max_score', default: 5, })
  maxScore: number;

  @Column({ name: 'question_text', })
  questionText: string;

  @Column({ name: 'disp_order', })
  dispOrder: number;

  @Column({ name: 'is_nps', })
  isNps: boolean;

  @Column({ name: 'is_nps_comment', })
  isNpsComment: boolean;

  @Column({ name: 'question_no', })
  questionNo: number;


  @OneToMany(() => CxQuestionOption, cxQuestionOption => cxQuestionOption.cxQuestion)
  cxQuestionOptions: CxQuestionOption[];

  constructor(props: TCxQuestion) {
    super();
    Object.assign(this, props);
  }
}

export declare type TCxQuestion = Omit<CxQuestion, 'dummy-no-such-field'>;
export interface ICxQuestion extends TCxQuestion {};
